<template>
  <a-modal width="45%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
<!--      <b>国际化配置  ({{originalValue}})</b>-->
      <b>国际化配置</b>
    </a-divider>
    <a-table rowKey="locale" :data-source="localeList" :columns="localeColumns" :pagination="false" bordered>
        <span slot="locale" slot-scope="text, record">
          <custom-dict-tag :options="customDict.LocaleEnum" :value="record.locale"/>
        </span>
      <div slot="localeValue" slot-scope="text, record" >
        <a-input v-if="inputType === 'input' " v-model="record.localeValue" :maxLength="128" :placeholder="$t('通用.输入.请输入')" />
        <a-input v-else-if="inputType === 'textarea' " type="textarea" v-model="record.localeValue" :maxLength="128" :placeholder="$t('通用.输入.请输入')" />
        <editor v-else-if="inputType === 'editor'" :ref="record.locale" v-model="record.localeValue" />
      </div>
<!--      <div slot="action" slot-scope="text, record">-->
<!--        <a-button type="primary" @click="getTranslation(record)">-->
<!--          {{$t('通用.按钮.翻译')}}-->
<!--        </a-button>-->
<!--      </div>-->
    </a-table>
  </a-modal>
</template>

<script>
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {translation} from "@/api/tool/common";
import Editor from '@/components/Editor'


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      localeList:[
      ],
      originalValue : null,
      /*input 或者 editor*/
      inputType : null,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('通用.文本.语言'),
          dataIndex: 'locale',
          key: 'locale',
          width: '100px',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('通用.文本.名称'),
          dataIndex: 'localeValue',
          scopedSlots: { customRender: 'localeValue' },
          key: 'localeValue'
        },
        // {
        //   title: this.$t('通用.文本.操作'),
        //   dataIndex: 'action',
        //   key: 'action',
        //   width: '12%',
        //   slots: { title: 'addbtn', customRender: 'brandName' },
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.localeList = [
      ]
      this.originalValue = null
    },
    /**
     *
     * @param inputType 类型, 输入框还是富文本
     * @param tableName 表名
     * @param fieldName 字段名
     * @param value 数值
     * @param localeValueList 原有的国际化
     */
    showLocaleField(inputType,tableName, fieldName, value, localeValueList) {
      this.inputType = inputType
      this.originalValue = value
      //初始化多语言
      let localeList = [];
      let i = 1 ;
      this.customDict.LocaleEnum.forEach(e => {
        localeList.push({"id":i,"tableName": tableName, 'tableField': fieldName, 'locale': e.type,'localeValue':''})
        i++;
      })
      if (localeValueList) {
        //原有localeValueList 填充进去
        localeList.forEach(locale => {
          localeValueList.forEach(data => {
            if (locale.locale === data.locale) {
              locale.localeValue = data.localeValue;
            }
          })
        })
      }
      this.localeList = localeList;
      this.open = true
    },
    async getTranslation(record) {
      if (!this.originalValue) {
        return Promise.resolve(); // 返回一个已解决的Promise
      }
      let data = { "text": this.originalValue, "locale": record.locale };
      try {
        const response = await translation(data);
        record.localeValue = response.data;
        return Promise.resolve(); // 标记这个翻译完成
      } catch (error) {
        console.error("Translation failed:", error);
        return Promise.reject(error); // 可以选择处理错误
      }
    },

    async onOk() {
      this.open = false;
      // 收集所有翻译Promise
      const translationPromises = this.localeList.map(locale => {
        if (!locale.localeValue) {
          return this.getTranslation(locale); // 返回每个翻译的Promise
        }
        return Promise.resolve(); // 如果已经有值，返回已解决的Promise
      });
      try {
        // 等待所有翻译完成
        await Promise.all(translationPromises);
        // 所有翻译完成后触发事件和重置
        this.$emit('localeChange', this.localeList);
        this.reset();
      } catch (error) {
        console.error("Some translations failed:", error);
        // 即使部分翻译失败，仍然触发事件和重置（根据业务需求调整）
        this.$emit('localeChange', this.localeList);
        this.reset();
      }
    }


  }
}
</script>
